import { ReportPrintTemplateModel, PrintTemplatesStatusResultDto } from './../models/report/report-print-template.model';
import { AxiosPromise } from "axios";
import { GenericServices } from "./generic.services";
import { ReportUri } from "../common";
import { ApiResponse } from "../models/app-configuration";
import { ReportSendEmailModel, SendEmailStatusResultDto, LargeMailingModel } from "../models/report";
import ReportStoreTypes from "../store/report/report-print-template/define-types.store";
import router from "../router";
import { ISaveSignEmailTemplateRequest, ISignEmailTemplatesResponse } from '../models/report/sign-email-template.model';
export class ReportServices extends GenericServices {
    changeInfoSendEmail(
        params: ReportSendEmailModel
    ): AxiosPromise<ReportSendEmailModel> {
        // ignore field before send to server
        let url = ReportUri.changeInfoSendMessage + params.ChangeInfoAction

        // ignore some field
        delete params.LookupInfos
        delete params.ChangeInfoAction
        delete params.EmailLookups;

        return super
            .executeSelectingPost(params, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    sendMessage(params: ReportSendEmailModel): AxiosPromise<ReportSendEmailModel> {
        // ignore some field
        //delete params.LookupInfos
        //delete params.ChangeInfoAction
        //delete params.EmailLookups;

        return super
            .executeSelectingPost(params, ReportUri.SendMessage)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    sendLargeMailing(params: LargeMailingModel, config?: any): AxiosPromise<LargeMailingModel> {

        return super
            .executePost(params, ReportUri.LargeMailing, config)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    /** LARGE MAILING
     * GET PERSONS WHO HAVE INVALID EMAIL/EMAIL COULD NOT BE SENT
    */
    getInvalidPersonEmails(personIds: number[]): AxiosPromise<any[]> {
        if (personIds.length <= 0)
            return Promise.reject('List of personIds must be more than 0');

        const params = { "Ids": personIds.join(",") };

        return super
            .executePost(params, ReportUri.getInvalidPersonEmails)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }


    checkInvalidPersonEmails(personCondition): AxiosPromise<any[]> {
        return super
            .executePost(personCondition, ReportUri.checkInvalidPersonEmails)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    checkInvalidDemandEmails(demandCondition): AxiosPromise<any[]> {
        return super
            .executePost(demandCondition, ReportUri.checkInvalidDemandEmails)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    previewMessage(params: ReportSendEmailModel): AxiosPromise<ReportSendEmailModel> {
        return super
            .executeSelectingPost(params, ReportUri.PreviewMessage + `${router.currentRoute.query.testError ? '?test-error=true' : ''}`) // TODO Remove query test-error after the task WA-2237 done.
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response);
            });
    }

    checkStatusSendMessage(sessionId: string): AxiosPromise<SendEmailStatusResultDto> {
        let url = ReportUri.CheckStatusSendMessage + sessionId;
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getHtmlContent(sessionId: string): AxiosPromise<SendEmailStatusResultDto> {
        let url = ReportUri.GetHtmlContent + sessionId;
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    sendPrintTemplate(params: ReportPrintTemplateModel): AxiosPromise<any> {
        return super
            .executeSelectingPost(params, ReportUri.sendPrintTemplate)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    checkStatusPrintTemplate(sessionId: string): AxiosPromise<PrintTemplatesStatusResultDto> {
        let url = ReportUri.CheckStatusPrintTemplate + sessionId;
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    // Large Mailing
    getBeePluginToken(): AxiosPromise<any> {
        const url = ReportUri.getBeePluginToken;
        return super
            .executeSelecting(null, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getBeePluginConfig(): AxiosPromise<any> {
        const url = ReportUri.getBeePluginConfig;
        return super
            .executeSelecting(null, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getAllTemplatesLargeMailing(langId): AxiosPromise<any> {
        const url = ReportUri.getAllTemplate + '?languageId=' + langId;
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    insertTemplate(template): AxiosPromise<any> {
        const url = ReportUri.insertTemplate;
        return super
            .executeSelectingPost(template, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    updateTemplate(original, current): AxiosPromise<any> {
        const url = ReportUri.updateTemplate.replace(':id', current.ID);
        return super
            .executeUpdatingCompare(original, current, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    deleteTemplate(templateId): AxiosPromise<any> {
        const url = ReportUri.deleteTemplate.replace(':id', templateId);
        return super
            .executeDeleting(url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }



    /** PRINT TEMPLATE 
     * GET_LOOKUP_TEMPLATES
    */
    [ReportStoreTypes.Service.GET_LOOKUP_TEMPLATES](data: any): AxiosPromise<SendEmailStatusResultDto> {
        let url = ReportUri.getPrintTemplateTempletesLookup;
        return super
            .executeSelectingPost(data, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    /** PRINT TEMPLATE 
     * GET_LOOKUP_DOCUMENTS
    */
    [ReportStoreTypes.Service.GET_LOOKUP_DOCUMENTS](propertyIds: number[]): AxiosPromise<SendEmailStatusResultDto> {
        if (propertyIds.length <= 0)
            return Promise.reject('List of propertyIds must be more than 0');
        let url = ReportUri.getPrintTemplateDocumentsLookup.replace(':propertyids', propertyIds.join(','));
        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    /**
     * SMS
     */
    getSmsTemplates(params: { PersonLanguageId?: number }): AxiosPromise<any> {
        return super
            .executeSelectingPost(params, ReportUri.getSmsTemplate)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getMessageTypes(): AxiosPromise<any> {
        return super
            .executeSelecting({}, ReportUri.getMessageTypes)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    updateSmsTemplates(payload: any): AxiosPromise<any> {
        return super
            .executeSelectingPost(payload, ReportUri.updateSmsTemplate)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    insertSmsTemplates(payload: any): AxiosPromise<any> {
        return super
            .executeSelectingPost(payload, ReportUri.insertSmsTemplate)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    renderSmsTemplate(params: any): AxiosPromise<any> {
        return super
            .executeSelectingPost(params, ReportUri.renderSmsTemplate)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getMessageTemplate(messageId: number) {
        const uri = ReportUri.getMessageTemplates.replace('{messageId}', messageId.toString());
        return super.executeSelecting(null, uri)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPropertyDocuments(propertyId: number) {
        const uri = ReportUri.getPropertyDocument.replace('{propertyId}', propertyId.toString());
        return super.executeSelecting(null, uri)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPersonDocuments(personId: number) {
        const uri = ReportUri.getPersonDocument.replace('{personId}', personId.toString());
        return super.executeSelecting(null, uri)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    checkInternationalPhones( payload: { PhoneNumbers: string[], LanguageId: number}) {
        const uri = ReportUri.checkInternationalPhones;
        return super.executeSelectingPost(payload, uri)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getDesignedMessageTemplates(payload: {objectID: string | number, messageType: number, language: number}) {
        const uri = ReportUri.getDesignedMessageTemplates;
        return super.executeSelecting(payload, uri)
        .then((response: ApiResponse) => {
            if (response.isSuccess) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.message);
        })
        .catch(ex => {
            console.log(ex);
            return Promise.reject(ex);
        });
    }

    async checkESignEmailTemplateExist(): Promise<{IsHasDEMessage: boolean, IsHasENMessage: boolean, IsHasNLMessage: boolean, IsHasFRMessage: boolean, ForcedLanguage?: number | null}> {
        const uri = ReportUri.checkESignEmailTemplateExist
        try {
            const response: ApiResponse =  await super.executeSelecting(null, uri)
            if (response.isSuccess) {
                return response.data;
            }
            throw new Error(response.message);
        } catch (ex) {
            console.log(ex);
            throw ex;
        }
    }

    /** Every signing-mail template (the Digital signing dropdowns) + per-language coverage + ForcedLanguage. */
    async getSignEmailTemplates(): Promise<ISignEmailTemplatesResponse> {
        const response: ApiResponse = await super.executeSelecting(null, ReportUri.getSignEmailTemplates);
        if (response?.isSuccess) return response.data;
        throw new Error(response?.message);
    }

    /**
     * Create (no Id) or update (Id) a signing-mail template. The server writes the same rows
     * and body files the Omnicasa desktop application authors, so the template is shared.
     */
    async saveSignEmailTemplate(payload: ISaveSignEmailTemplateRequest): Promise<{ Id: number }> {
        const response: ApiResponse = await super.executeSelectingPost(payload, ReportUri.signEmailTemplate);
        if (response?.isSuccess) return response.data;
        throw new Error(response?.message);
    }

    async deleteSignEmailTemplate(id: number): Promise<boolean> {
        const response: ApiResponse = await super.executeDeleting(`${ReportUri.signEmailTemplate}/${id}`) as unknown as ApiResponse;
        if (response?.isSuccess) return true;
        throw new Error(response?.message);
    }

    constructor() {
        super();
    }
}
